import { FormLayout } from "@careinfo/layout";
import { AccessControl } from "@careinfo/permission-required";
import { tw } from "@careinfo/tailwind";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { ClipboardEvent, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import APIS from "../../constant/EndPoint";
import { getApiData } from "../../helpers/AxiosInstance";
import { createPickupRequestValidationForm } from "../../utils/validationSchemas";
import DriverForm from "../DriverForm";
import Card from "../Reusable/Card";
import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import TrackingCell from "../Reusable/DataTable/TrackingCell";
import Modal from "../Reusable/Modal";
import VehicleForm from "../VehicleForm";
import PickupRequestForm from "./CourierPickupRequestForm";
import { useQueryClient } from "@tanstack/react-query";
import ChangeStatus from "./ChangeStatus";

const EditCourierPickupRequest = (props: any) => {
  const [searchParams, setSearchParms] = useSearchParams({
    limit: "10",
    page: "0",
    searchQuery: "",
  });
  const [orderId, setOrderId] = useState(null);
  const [senderId, setSenderId] = useState(null);
  const [statusData, setStatusData] = useState<any>([]);
  const [statuslist, setStatusList] = useState<any>([]);
  const queryClient = useQueryClient();

  const {
    isLoading,
    data,
    handleAttachConsignment,
    handleToggleMarkAsDone,
    defaultValue,
    setDefaultValue,
    gridData,
    handlecheckConsignments,
    handleAddVehicle,
    isVehicleLoading,
    handleAddDriver,
    isDriverLoading,
    handlecheckConsignmentsPickup,
    handleStatusChange,
    handleUpdate,
    openAddDriverPopup,
    openAddVehiclePopup,
    setOpenAddDriverPopup,
    setOpenAddVehiclePopup,
  } = props;
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    watch,
    control,
    clearErrors,
  } = useForm<any>({
    resolver: yupResolver(createPickupRequestValidationForm),
    defaultValues: async () => {
      return {
        ...data,
        driver: {
          name: data?.driver?.user?.full_name,
          id: data?.driver?.id,
        },
        vehicle: {
          name: data?.vehicle?.license_number,
          id: data?.vehicle?.id,
        },
        note: data?.note,
        order_count: data?.order_count,
        priority: {
          id: data?.priority,
          name: data?.priority,
        },
      };
    },
  });

  const handleKeyDown = (event: any) => {
    if (event.key === "Enter" && event.target.value?.length > 0) {
      setOrderId(event.target.value);
      if (!data?.is_active) {
        handlecheckConsignments(event.target.value, setError);
      }

      event.target.value = "";
    }
  };
  const handleKeyDownPickup = (event: any) => {
    if (event.key === "Enter" && event.target.value?.length > 0) {
      if (!data?.is_active) {
        handlecheckConsignmentsPickup(event.target.value, setError);
      } else if (statusData?.length > 1 && defaultValue?.length === 1) {
        handleAttachConsignment(
          event.target.value,
          defaultValue[0]?.id,
          setError
        );
      } else if (statusData?.length === 1) {
        handleAttachConsignment(
          event.target.value,
          statusData[0]?.id,
          setError
        );
      } else {
        toast.error("Please select one status first");
      }
      event.target.value = "";
    }
  };

  const defaultColumns: any = [
    {
      header: "Waybill",
      accessorKey: "order.tracking_number",
      cell: TrackingCell,
    },
    {
      header: "Vendor",
      accessorKey: "order.vendor.user.full_name",
      cell: NACell,
    },
    {
      header: "Origin",
      accessorKey: "order.pickup_branch.name",
      cell: NACell,
    },
    {
      header: "Destination",
      accessorKey: "order.destination.name",
      cell: NACell,
    },
    {
      header: "Weight",
      accessorKey: "order.weight",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>
              {row?.original?.order?.package_type?.unit === "Gm"
                ? Number(getValue() * 1000) || 0
                : getValue() || 0}
              <span className="text-gray-500 text-xs">
                {row?.original?.order?.package_type?.unit}
              </span>
            </p>
          </>
        );
      },
    },
    {
      header: "Pieces",
      accessorKey: "order.piece",
      cell: NACell,
    },
    {
      header: "Received",
      accessorKey: "is_received",
      cell: ({ cell: { getValue }, row }) => {
        const orderValue = row?.original?.order?.tracking_number;

        const handleReceivedClick = async () => {
          setOrderId(orderValue);
          if (!data?.is_active) {
            await handlecheckConsignments(orderValue, setError);
            queryClient.invalidateQueries({
              queryKey: ["pickup-request-items"],
            });
          }
        };

        return getValue() ? (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M22 11.08V12C21.9988 14.1564 21.3005 16.2547 20.0093 17.9818C18.7182 19.709 16.9033 20.9725 14.8354 21.5839C12.7674 22.1953 10.5573 22.1219 8.53447 21.3746C6.51168 20.6273 4.78465 19.2461 3.61096 17.4371C2.43727 15.628 1.87979 13.4881 2.02168 11.3363C2.16356 9.18457 2.99721 7.13633 4.39828 5.49707C5.79935 3.85782 7.69279 2.71538 9.79619 2.24015C11.8996 1.76491 14.1003 1.98234 16.07 2.86M22 4L12 14.01L9.00001 11.01"
              stroke="#26C943"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ) : (
          <div onClick={handleReceivedClick} className="cursor-pointer">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15 9L9 15M9 9L15 15M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
                stroke="red"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        );
      },
    },
  ];

  const handleOrderDetailNavigate = (row: any) => {
    console.log(row);
  };
  const preventCopyPaste = (e: ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    toast.error("Copy and paste is not allowed here");
  };

  const handleSearch = (value) => {
    searchParams.set("searchQuery", value);

    setSearchParms(searchParams);
  };
  useEffect(() => {
    if (Array.isArray(gridData?.results)) {
      setStatusList([...gridData?.results]);
    }
  }, [gridData]);
  useEffect(() => {
    if (Array.isArray(statuslist)) {
      const status = statuslist?.filter((x: any) => x?.name === "Intermediate");
      setStatusData(status[0]?.status_id);
    }
  }, [statuslist]);

  const handleAutoFill = async (id: any) => {
    const url = `${APIS.MERCHANT}${id}/`;
    try {
      const res = await getApiData(url);
      if (res?.status === 200) {
        setValue("sender_primary_contact", res?.data?.user_info?.mobile_number);
        setValue("sender_address", res?.data?.default_sender?.address);
      }
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    if (senderId) {
      setValue("merchant", senderId);
      handleAutoFill(senderId);
    }
  }, [senderId]);

  return (
    <>
      <AccessControl
        children={
          <FormLayout
            handleSubmit={handleSubmit}
            handleFormSubmit={handleUpdate}
            setError={setError}
            buttonLabel={"Submit"}
            isLoading={isLoading}
            disabled={!data?.is_active}
          >
            <PickupRequestForm
              register={register}
              errors={errors}
              setValue={setValue}
              getValues={getValues}
              clearErrors={clearErrors}
              watch={watch}
              control={control}
              isCteate={false}
              setOpenAddDriverPopup={setOpenAddDriverPopup}
              setOpenAddVehiclePopup={setOpenAddVehiclePopup}
              setSenderId={setSenderId}
            />
          </FormLayout>
        }
        allowedPermissions={["can_editupdate_pickup_request"]}
      />
      {data?.is_active ? (
        <Card title="Barcode Scanner">
          <>
            <div className={tw`flex flex-col  items-end w-full`}>
              <div
                className={tw`flex flex-row gap-x-4 items-center w-full justify-end`}
              >
                <ChangeStatus
                  gridData={statusData}
                  defaultValue={defaultValue}
                  handleStatusChange={handleStatusChange}
                />
              </div>

              <div className={tw`grid grid-cols-1 w-full`}>
                <div>
                  <input
                    type="text"
                    {...register("tracking_number")}
                    className={tw`w-full focus:outline-none bg-[#EEF5F4] p-2 mt-1`}
                    onPaste={preventCopyPaste}
                    onKeyDown={handleKeyDownPickup}
                  />
                  {errors?.tracking_number && (
                    <p className={tw`text-red-500 text-xs my-1`}>
                      {errors?.tracking_number?.message}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </>
        </Card>
      ) : (
        <Card title="Barcode Scanner">
          <div className={tw`grid grid-cols-1`}>
            <div>
              <input
                type="text"
                className={tw`w-full focus:outline-none bg-[#EEF5F4] p-2 mt-1`}
                onPaste={preventCopyPaste}
                onKeyDown={handleKeyDown}
              />
            </div>
          </div>
        </Card>
      )}

      <DataTable
        url={APIS.PICKUPREQUEST_ITEMS}
        queryKey={"pickup-request-items"}
        columns={defaultColumns}
        params={{ pickup_request: data?.id }}
        subOrderSearch={true}
        tableName={"pickup-request-items"}
        handleEditNavigate={handleOrderDetailNavigate}
        actionMenu={
          <div className={tw`w-full text-right`}>
            {data?.is_active ? (
              <button
                className={tw`p-1 px-5 rounded-sm border border-primary mr-2`}
                onClick={handleToggleMarkAsDone}
              >
                Mark As Done
              </button>
            ) : (
              ""
            )}
          </div>
        }
      />
      <Modal
        isOpen={openAddVehiclePopup}
        setIsOpen={setOpenAddVehiclePopup}
        title={"Add Vehicle"}
        children={
          <>
            <VehicleForm
              register={register}
              errors={errors}
              handleSubmit={handleSubmit}
              handleAddVehicle={handleAddVehicle}
              isVehicleLoading={isVehicleLoading}
            />
          </>
        }
      />
      <Modal
        isOpen={openAddDriverPopup}
        setIsOpen={setOpenAddDriverPopup}
        title={"Add Driver"}
        children={
          <>
            <DriverForm
              register={register}
              errors={errors}
              handleSubmit={handleSubmit}
              setValue={setValue}
              getValues={getValues}
              clearErrors={clearErrors}
              handleAddDriver={handleAddDriver}
              isDriverLoading={isDriverLoading}
            />
          </>
        }
      />
    </>
  );
};

export default EditCourierPickupRequest;

